import React from 'react';

function Datenschutz() {
  return (
    <div className='page-wrapper' style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.6' }}>
      <h1>Datenschutzerklärung</h1>

      <h2>1. Verantwortlicher</h2>
      <p>
        Balancor GmbH<br />
        Vertreten durch: Wahid Hamidy<br />
        Dieselstraße 2<br />
        41469 Neuss<br />
        Deutschland<br />
        E-Mail: info@balancor.de
      </p>

      <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
      <p>
        Wir erheben und verarbeiten ausschließlich die personenbezogenen Daten, die Sie uns aktiv mitteilen,
        wenn Sie sich für unseren Launch anmelden (z. B. Ihre E-Mail-Adresse).
      </p>

      <h2>3. Zweck der Datenverarbeitung</h2>
      <p>
        Ihre Daten werden ausschließlich genutzt, um Sie über den Start unseres Angebots zu informieren
        und ggf. weitere Informationen zu unserem Unternehmen und unseren Produkten zuzusenden.
      </p>

      <h2>4. Rechtsgrundlage</h2>
      <p>
        Die Verarbeitung erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
      </p>

      <h2>5. Speicherung und Löschung</h2>
      <p>
        Ihre Daten werden nur so lange gespeichert, wie es für den genannten Zweck erforderlich ist,
        oder bis Sie Ihre Einwilligung widerrufen. Danach werden die Daten unverzüglich gelöscht.
      </p>

      <h2>6. Weitergabe von Daten</h2>
      <p>
        Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, es sei denn, wir nutzen einen externen
        E-Mail-Dienstleister (z. B. Mailchimp, Brevo). In diesem Fall erfolgt die Weitergabe nur,
        soweit dies zur Durchführung des Versands notwendig ist.
      </p>

      <h2>7. Ihre Rechte</h2>
      <p>
        Sie haben das Recht,
      </p>
      <ul>
        <li>Auskunft über Ihre gespeicherten personenbezogenen Daten zu erhalten (Art. 15 DSGVO)</li>
        <li>Berichtigung unrichtiger Daten zu verlangen (Art. 16 DSGVO)</li>
        <li>Löschung Ihrer Daten zu verlangen (Art. 17 DSGVO)</li>
        <li>die Einschränkung der Verarbeitung zu verlangen (Art. 18 DSGVO)</li>
        <li>der Verarbeitung zu widersprechen (Art. 21 DSGVO)</li>
        <li>Ihre Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO)</li>
        <li>sich bei einer Aufsichtsbehörde zu beschweren (Art. 77 DSGVO)</li>
      </ul>

      <h2>8. Kontakt</h2>
      <p>
        Für Fragen zur Verarbeitung Ihrer personenbezogenen Daten wenden Sie sich bitte an:<br />
        E-Mail: info@balancor.de
      </p>
    </div>
  );
}

export default Datenschutz;
